(function () {
    class ViewOrderController {
        scope;
        order;
        customer;
        dateTimeFormat;
        currencyFormat;
        state;
        stateParams;
        uibModal;
        orderService;
        permissionService;
        localisationService;
        isLoading = true;
        constructor(
            $scope,
            $timeout,
            OrderService,
            PermissionService,
            LocalisationService,
            $state,
            $stateParams,
            $uibModal) {
            this.scope = $scope;
            this.timeout = $timeout;
            this.state = $state;
            this.stateParams = $stateParams;
            this.uibModal = $uibModal;
            this.orderService = OrderService;
            this.permissionService = PermissionService;
            this.localisationService = LocalisationService;
            this.initialise();
        }
        /**
         * Navigates to the list orders page with the customers mobile number as a filter.
         */
        viewCustomerOrders() {
            const filter = {};
            filter.MobileNumber = this.customer?.MobileNumber;
            filter.StoreId = this.state.params.StoreId;

            // We go to different paths depending on the current context
            if (this.permissionService.userContext.ContextType === Dashboard.ContextTypes.StoreContext) {
                filter.StoreId = this.state.params.StoreId;
                this.state.go("app.storeorders", filter);
            } else if (this.permissionService.userContext.ContextType === Dashboard.ContextTypes.CallCenterContext) {
                filter.StoreId = this.state.params.StoreId;
                this.state.go("app.callcenterorders", filter);
            } else if (this.permissionService.userContext.ContextType === Dashboard.ContextTypes.BrandContext) {
                filter.StoreId = this.state.params.StoreId;
                this.state.go("app.brandorders", filter);
            }
        }

        canRefund() {
            if (!this.order) {
                return false;
            }
            const hasPermission = this.permissionService
                .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.ActionRefunds);
            if (!hasPermission) {
                return false;
            }
            return this.order.IsSuccess === true
                && (this.order.CardPaymentStateId === Dashboard.CreditCardPaymentStates.Paid
                    || this.order.VoucherIsReversible);
        }

        showRefundModal() {
            const order = this.order;
            const callback = () => this.loadOrder();
            this.uibModal.open({
                animation: true,
                templateUrl: "components/orders/vieworder/orderrefundmodal.61e53758.html",
                controller: "OrderRefundModalController",
                size: "lg",
                backdrop: "static",
                resolve: {
                    orderGuid: function () {
                        return order.OrderGuid;
                    },
                    callback: function () {
                        return callback;
                    }
                }
            });
        };

        async loadOrder() {
            this.validateUserHasPermissionToViewOrderDetails();
            this.orderGuid = this.stateParams.id;
            const result = await this.orderService.getOrder(this.orderGuid);
            if (!result.data) {
                return;
            }
            this.order = new Dashboard.Models.Order(result.data.Order);
            this.customer = result.data.Customer;
            this.timeout(() => this.isLoading = false);
        }

        validateUserHasPermissionToViewOrderDetails() {
            if (this.permissionService.userContext.isBrandContext()) {
                this.hasPermissionToViewBrandOrderDetails();
            } else if (this.permissionService.userContext.isStoreContext()) {
                this.hasPermissionToViewStoreOrderDetails();
            }
        }

        hasPermissionToViewBrandOrderDetails() {
            const userBrands = this.permissionService.getUserContextBrandIds();
            const brandId = parseInt(this.stateParams.brandId);
            if (!userBrands.includes(brandId)) {
                this.permissionService.navigateToAccessDenied();
            }
        }

        hasPermissionToViewStoreOrderDetails() {
            const userStores = this.permissionService.getUserContextStoreIds();
            const storeId = parseInt(this.stateParams.storeId);
            if (!userStores.includes(storeId)) {
                this.permissionService.navigateToAccessDenied();
            }
        }

        shouldShowRestaurantName() {
            return this.permissionService
                .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.BrandCustomerSupportAgent);
        }

        orderChannel() {
            switch (this.order.ChannelId) {
                case Dashboard.OrderChannels.Android:
                case Dashboard.OrderChannels.iOS: {
                    return "App";
                }
                case Dashboard.OrderChannels.Website: {
                    return "Website";
                }
                case Dashboard.OrderChannels.CallCenter: {
                    return "Call Center";
                }
                default: {
                    return "Unknown";
                }
            }
        }

        orderStatus() {
            return this.order.IsSuccess
                ? "Success"
                : "Fail";
        }

        paymentMethod() {
            const paidInStore = this.order.PaymentType
                === Dashboard.OrderPaymentType.PayInStore;
            const paidOnline = this.order.PaymentType
                === Dashboard.OrderPaymentType.PayOnline;
            if (paidInStore) {
                return "In Store";
            }
            if (paidOnline) {
                return "Paid Online";
            }
            return this.order.PaymentMethodAsString;
        }

        acceptedMethod() {
            switch (this.order.AcceptedMethod) {
                case Dashboard.OrderAcceptedMethod.POS: {
                    return "Point Of Sale";
                }
                case Dashboard.OrderAcceptedMethod.GSM: {
                    return "Printer";
                }
                case Dashboard.OrderAcceptedMethod.Web: {
                    return "Web";
                }
            }
        }

        navigateToParentUrl() {
            const parentState = Dashboard.helpers.stateHelper.getParentState(this.state.current.name);
            return this.state.href(parentState);
        }

        /**
         * Initialises the controller and sets up the scope variables
         */
        async initialise() {
            this.dateTimeFormat = this.localisationService.Configuration.DateTimeFilterFormat;
            this.currencyFormat = this.localisationService.Configuration.CurrencyFormat;
            this.scope.$on(Dashboard.Events.UserContextChanged, () => {
                this.viewCustomerOrders();
            });
            await this.loadOrder();
        }
    }
    angular
        .module("dashboard")
        .component("viewOrder",
            {
                templateUrl: "components/orders/vieworder/vieworder.ae8a6540.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$timeout",
                    "OrderService",
                    "PermissionService",
                    "LocalisationService",
                    "$state",
                    "$stateParams",
                    "$uibModal",
                    ViewOrderController
                ]
            });
})();

